// src/composables/WindIcon.ts
export default class WindIcon {
  static getIconUrl(windDir?: number, windVel?: number): string {
    if (typeof windDir !== 'number' || typeof windVel !== 'number') {
      return this.resolve('rank00/99.png')
    }

    if (windVel < 0.3) {
      return this.resolve('rank00/00.png')
    }

    const rank = this.getRank(windVel)
    const dir = this.getDirectionCode(windDir)

    return this.resolve(`${rank}/${dir}.png`)
  }

  private static resolve(path: string): string {
    return new URL('/images/wind/' + path, import.meta.url).href
  }

  private static getRank(v: number): string {
    if (v < 3) return 'rank01'
    if (v < 5) return 'rank02'
    if (v < 7) return 'rank03'
    if (v < 10) return 'rank04'
    if (v < 12) return 'rank05'
    if (v < 15) return 'rank06'
    return 'rank07'
  }

  private static getDirectionCode(dir: number): string {
    // ① 0〜359に正規化
    const d = ((dir % 360) + 360) % 360

    // ② 協会の表そのまま
    const table = [
      { min: 348.75, max: 360, code: '16' }, // 北
      { min: 0, max: 11.25, code: '16' }, // 北
      { min: 11.25, max: 33.75, code: '01' }, // 北北東
      { min: 33.75, max: 56.25, code: '02' }, // 北東
      { min: 56.25, max: 78.75, code: '03' }, // 北東東
      { min: 78.75, max: 101.25, code: '04' }, // 東
      { min: 101.25, max: 123.75, code: '05' }, // 東南東
      { min: 123.75, max: 146.25, code: '06' }, // 南東
      { min: 146.25, max: 168.75, code: '07' }, // 南南東
      { min: 168.75, max: 191.25, code: '08' }, // 南
      { min: 191.25, max: 213.75, code: '09' }, // 南南西
      { min: 213.75, max: 236.25, code: '10' }, // 南西
      { min: 236.25, max: 258.75, code: '11' }, // 西南西
      { min: 258.75, max: 281.25, code: '12' }, // 西
      { min: 281.25, max: 303.75, code: '13' }, // 西北西
      { min: 303.75, max: 326.25, code: '14' }, // 北西
      { min: 326.25, max: 348.75, code: '15' }, // 北北西
    ]

    for (const row of table) {
      if (d >= row.min && d < row.max) {
        return row.code
      }
    }

    return '99'
  }
}
